// extracted by mini-css-extract-plugin
export default {"advertDetailService__label":"c-k_hc","advertDetailService__price":"c-k_he"};